import {Alert, Button, Typography} from 'antd';
import DBModal from 'components/modal/modal';
import styles from '../kybDashboard.module.scss';

const {Text} = Typography;

/**
 * Confirms submitting the account for review on the business's behalf — for a
 * business that sent its files another way. It is the business's own submit:
 * the checklist is re-checked server-side and the business is emailed.
 */
export const SubmitForReviewModal = ({
  open,
  entityName,
  submitting,
  onClose,
  onSubmit,
}) => (
  <DBModal
    isOpen={open}
    handleClose={submitting ? undefined : onClose}
    width={520}
    destroyOnClose
    content={
      <div className={styles.modalBody}>
        <h2 className={styles.modalTitle}>Submit for review</h2>
        <Text type="secondary">{entityName || 'This business'}</Text>
        <Text className={styles.modalField}>
          Submits this verification as if the business had pressed Submit. It
          moves to Submitted and joins the review queue.
        </Text>
        <Alert
          type="info"
          showIcon
          className={styles.modalField}
          message='The business gets the usual "submission received" email.'
          description="If anything required is still missing, nothing moves and you will see what is outstanding."
        />
        <div className={styles.modalActions}>
          <Button onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="primary" loading={submitting} onClick={onSubmit}>
            Submit for review
          </Button>
        </div>
      </div>
    }
  />
);
